import axiosInstance from "config/AxiosConfig";
import { BaseResponse } from "domain/payload/response/BaseResponseDto";
import { RoleListResp } from "domain/payload/response/RBAC/RoleListResp";
import { RoleDetailResp } from "domain/payload/response/RBAC/RoleDetailResp";
import { PrivilegeListResp } from "domain/payload/response/RBAC/PrivilegeListResp";

const RBACService = () => {
  const getRoleList = async (
    token: string,
    page?: number,
    size?: number,
    search?: string | null
  ): Promise<BaseResponse<RoleListResp[]>> => {
    try {
      const response = await axiosInstance.get(`/v1/legacy/cms/rbac/role-list`, {
        headers: { Authorization: `Bearer ${token}` },
        params: { page, size, search },
      });
      return response.data;
    } catch (error: any) {
      throw error.response?.data?.message || error.message;
    }
  };

  const getRoleDetail = async (
    token: string,
    id: string
  ): Promise<BaseResponse<RoleDetailResp>> => {
    try {
      const response = await axiosInstance.get(`/v1/legacy/cms/rbac/role-detail`, {
        headers: { Authorization: `Bearer ${token}` },
        params: { id },
      });
      return response.data;
    } catch (error: any) {
      throw error.response?.data?.message || error.message;
    }
  };

  const getPrivilegeList = async (
    token: string,
    page?: number,
    size?: number,
    search?: string | null
  ): Promise<BaseResponse<PrivilegeListResp[]>> => {
    try {
      const response = await axiosInstance.get(`/v1/legacy/cms/rbac/priviledge-list`, {
        headers: { Authorization: `Bearer ${token}` },
        params: { page, size, search },
      });
      return response.data;
    } catch (error: any) {
      throw error.response?.data?.message || error.message;
    }
  };

  const saveRoleAccess = async (
    token: string,
    roleId: string,
    priviledgeIds: string[],
    userId: string
  ): Promise<BaseResponse<null>> => {
    try {
      const response = await axiosInstance.post(
        `/v1/legacy/cms/rbac/role-update`,
        {
          roleId,
          priviledgeIds,
          userId,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      return response.data;
    } catch (error: any) {
      throw error.response?.data?.message || error.message;
    }
  };

  return {
    getRoleList,
    getRoleDetail,
    getPrivilegeList,
    saveRoleAccess,
  };
};

export default RBACService;
